import { Table } from "antd";

class UsefulFunctions {
  static calculateFooterCells = (data, columns) => {
    let cells = [];
    let count = 0;
    data.map((record, i) => {
      columns.map((column, i1) => {
        if (column.isSum) {
          const a = cells[i1] ? cells[i1] : 0;
          const b = record[column.dataIndex] ? record[column.dataIndex] : 0;
          cells[i1] = cells[i1] ? a + b : record[column.dataIndex];
          count += cells[i1];
          return cells[i1];
        } else {
          cells[i1] = "";
          return cells[i1];
        }
      });
      return record;
    });
    return { cells, count };
  };

  static checkPermission = (auth, permission) => {
    if (auth && auth.user) {
      if (permission) {
        let res = permission.find((x) => x === auth.user.type);
        if (res) {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  };

  static renderSummaryCell = (value, key, isPrint) => {
    if (isPrint) {
      return (
        <td
          key={key}
          style={{
            border: "1px solid black",
            paddingRight: "3px",
            paddingLeft: "3px",
          }}
          index={key}
          className="font-bold text-right"
        >
          {value
            ? new Intl.NumberFormat().format(Math.round(value * 100) / 100)
            : " "}
        </td>
      );
    }
    return (
      <Table.Summary.Cell
        key={key}
        index={key}
        className="font-bold text-right"
      >
        {value
          ? new Intl.NumberFormat().format(Math.round(value * 100) / 100)
          : " "}
      </Table.Summary.Cell>
    );
  };

  static renderSummary = ({ data, columns, isPagination, isPrint }) => {
    if (isPagination) {
      return columns.map((col, i) => {
        if (col.children && col.children.length > 0) {
          return col.children.map((childCol, childi) => {
            if (data && data[childCol.dataIndex])
              return this.renderSummaryCell(
                data[childCol.dataIndex],
                childi,
                isPrint
              );
            return this.renderSummaryCell(null, childi, isPrint);
          });
        }
        if (data && data[col.dataIndex])
          return this.renderSummaryCell(data[col.dataIndex], i, isPrint);
        return this.renderSummaryCell(null, i, isPrint);
      });
    } else {
      let { cells, count } = this.calculateFooterCells(data, columns);
      if (count === 0) return null;
      return cells.map((item, i) => this.renderSummaryCell(item, i, isPrint));
    }
  };

  static renderSummaryRow = ({ footer, columns, isPagination, isPrint }) => {
    if (footer) {
      return footer.map((item, i) => {
        if (isPrint) {
          return (
            <tr>
              {this.renderSummary({
                data: item,
                columns,
                isPagination,
                isPrint,
              })}
            </tr>
          );
        } else {
          return (
            <Table.Summary.Row key={i}>
              {this.renderSummary({
                data: item,
                columns,
                isPagination,
                isPrint,
              })}
            </Table.Summary.Row>
          );
        }
      });
    }
    return null;
  };

  static checkSetProducts = (listOne, listTwo) => {
    if (listOne === undefined || listTwo === undefined) return false;
    if (listOne.length !== listTwo.length) return false;
    let isValid = true;
    listOne.map((item) => {
      let result = listTwo.find(
        (x) => x.productid === item.productid && x.spiceid === item.spiceid
      );
      if (!result) isValid = false;
    });
    return isValid;
  };

  static getSetDetailItem = (sub, spice) => {
    let tmp = {
      productid: spice ? spice.productid : sub.productid,
      productname: sub.name,
      barcode: null,
      qty: 0,
      buyqty: spice ? spice.buyqty : sub.buyqty,
      spiceid: spice ? spice.spicesid : 0,
      spicename: spice ? spice.name : "",
      price: sub.price,
      amount: sub.price,
      discount: 0,
      unitdiscount: 0,
      totalamount: sub.price,
    };

    return tmp;
  };
}

export default UsefulFunctions;
